import { UseFormReturn } from 'react-hook-form';
import { MemoType, Task } from 'models/Memo';
import { FormValues } from './hooks/useFormInitialisation';
import { useTranslations } from 'next-intl';

interface Props {
  watch: UseFormReturn<FormValues>['watch'];
}

export const TaskProgress: React.FC<Props> = ({ watch }) => {
  const t = useTranslations();
  const selectedMemoType = watch('type');
  const watchedTasks = watch('tasks') as unknown as Task[] | undefined;
  const taskTotal = watchedTasks?.length ?? 0;
  const taskCompleted =
    watchedTasks?.filter((task) => task?.isCompleted).length ?? 0;

  if (selectedMemoType !== MemoType.TaskList || taskTotal === 0) return null;

  return (
    <div className={styles.root}>
      <span className={styles.label}>
        {t('memoComposer.taskProgress', {
          done: taskCompleted,
          total: taskTotal,
        })}
      </span>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{ width: `${(taskCompleted / taskTotal) * 100}%` }}
        />
      </div>
    </div>
  );
};

const styles = {
  root: 'flex items-center gap-2',
  label: 'text-[11px] text-ink-secondary',
  track: 'h-1 w-14 rounded-full bg-ink-secondary/20 overflow-hidden',
  fill: 'h-full rounded-full bg-accent-fill transition-[width]',
};
